<script setup lang="ts">
import { Button } from "@toruslabs/vue-components/Button";

import IconBack from "../../assets/claim/icon-back.svg";
// Assets
import MocaNonFound from "../../assets/claim/moca-non-found.svg";
import MetamaskLoginFactory from "../../handlers/Auth/MetamaskFactory";
import { useClaimStore } from "../../store/claimStore";
import { useControllerStore } from "../../store/controllerStore";

const claimStore = useClaimStore();
const controllerStore = useControllerStore();

async function onBack() {
  const metamask = await MetamaskLoginFactory.getInstance({
    providerConfig: controllerStore.networkProviderConfig,
    onLogout: controllerStore.logout,
  });
  if (metamask.connnected) {
    metamask.disconnect();
  }
  claimStore.mocaNFTAddress = "";
  claimStore.mocaSignature = "";
  claimStore.showClaimMethods();
}
</script>

<template>
  <Button class="mb-2 !text-moca-gray-3 !text-sm !font-semibold !bg-moca-transparent !px-0" @on-click="() => onBack()">
    <img :src="IconBack" class="w-4" />
    <p>Back</p>
  </Button>
  <div class="flex flex-col items-center justify-center gap-6 tab:min-h-[400px]">
    <img :src="MocaNonFound" />
    <p class="text-white text-center text-xl font-bold">No eligible Mocas found in wallet</p>
    <p class="text-moca-white-80 text-center text-base font-normal">
      You need at least 1 eligible Moca (staked for at least 1 staking period) to claim your Moca ID.
      <br /><br />
      Or maybe ask your friend for an invite code.
    </p>
    <Button
      class="mt-12 !bg-moca-yellow !text-black !text-lg !font-bold !border !border-black !h-14 !rounded-full !px-6"
      @on-click="claimStore.chooseClaimMethod('code')"
    >
      Use Invite Code
    </Button>
  </div>
</template>
